import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16 lg:pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1D3A] mb-8">
            Privacy Policy
          </h1>
          <p className="text-sm text-slate-500 mb-8">Last updated: February 2026</p>

          <div className="prose prose-slate max-w-none">
            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">1. Introduction</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Ultimate Infusions Private Limited ("we," "our," or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you 
                visit our website or use our services.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">2. Information We Collect</h2>
              <p className="text-slate-600 leading-relaxed mb-4">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4">
                <li><strong>Personal Information:</strong> Name, email address, phone number, company name when you submit our contact form or partner inquiry.</li>
                <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and browser type.</li>
                <li><strong>Device Information:</strong> IP address, device type, operating system, and browser information.</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">3. How We Use Your Information</h2>
              <p className="text-slate-600 leading-relaxed mb-4">We use the collected information to:</p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4">
                <li>Respond to your inquiries and provide customer support</li>
                <li>Process partnership and business inquiries</li>
                <li>Send relevant updates about our products and services (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">4. Information Sharing</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may share your 
                information only in the following circumstances:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4">
                <li>With service providers who assist in operating our website and business</li>
                <li>To comply with legal requirements or respond to lawful requests</li>
                <li>To protect our rights, privacy, safety, or property</li>
                <li>With your explicit consent</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">5. Data Security</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We implement appropriate technical and organizational security measures to protect your personal 
                information against unauthorized access, alteration, disclosure, or destruction. However, no method 
                of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">6. Cookies</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Our website may use cookies and similar tracking technologies to enhance your browsing experience. 
                You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">7. Your Rights</h2>
              <p className="text-slate-600 leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent where applicable</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">8. Contact Us</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
              </p>
              <div className="bg-slate-50 p-6 rounded-xl">
                <p className="text-slate-700 font-semibold">Ultimate Infusions Private Limited</p>
                <p className="text-slate-600 mt-2">S5, Br Apartments, Chinna Thokatta, Malani Society</p>
                <p className="text-slate-600">Hyderabad - 500011, Telangana, India</p>
                <p className="text-slate-600 mt-2">Email: info@ultimateinfusions.com</p>
                <p className="text-slate-600">Phone: +91 9110725125</p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">9. Changes to This Policy</h2>
              <p className="text-slate-600 leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with 
                an updated revision date. We encourage you to review this policy periodically.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
